import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { getClassName } from '../../../utils'

import './textArea.component.scss'

/**
 * TextArea
 */
class TextArea extends PureComponent {
  /**
   * Render
   * @return {XML}
   */
  render () {
    const {
      id,
      name,
      className,
      placeholder,
      value,
      onChange,
      onBlur,
      maxLength,
      rows,
      newline
    } = this.props

    const baseClassName = getClassName('text-area', [
      { condition: className, trueClassName: className },
      { condition: newline, trueClassName: 'text-area_field--new-line' }
    ])

    return (
      <div className={baseClassName}>
        <textarea
          id={id}
          name={name}
          className='text-area_field'
          placeholder={placeholder}
          value={value}
          maxLength={maxLength}
          rows={rows}
          onChange={onChange}
          onBlur={onBlur}
        />
      </div>
    )
  }
}

TextArea.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  maxLength: PropTypes.number,
  newline: PropTypes.bool
}

TextArea.defaultProps = {
  placeholder: '',
  rows: 6,
  newline: true
}

export default TextArea
